import Calculator from "./Calculator"
import { maxNumBoxesFitInBag } from "./util/calculations.js"
import { FormattedMessage } from "react-intl"
import withI18n from "../i18n/withI18n"
import Layout from "./Layout"

class App extends React.Component {
  state = {
    displayBoxes: [],
    displayBags: [],
  }

  setContainerState = (dimensions) => {
    const displayBags = this.calculateContainers("bags", dimensions)
    const displayBoxes = this.calculateContainers("boxes", dimensions)

    this.setState(
      {
        displayBoxes: displayBoxes.sort((a, b) => a.numBoxes < b.numBoxes),
        displayBags: displayBags.sort((a, b) => a.numBoxes < b.numBoxes),
      },
      () => this.redirect(dimensions)
    )
  }

  calculateContainers = (containerType, dimensions) => {
    const displayContainers = []

    this.props[containerType].map((container) => {
      const numBoxes = maxNumBoxesFitInBag(container, dimensions)
      if (numBoxes > 0) {
        displayContainers.push(
          this.copyContainer(container, containerType, dimensions, numBoxes)
        )
      }
    })

    return displayContainers
  }

  copyContainer = (container, containerType, dimensions, numBoxes) => {
    const containerCopy = Object.assign({}, container)
    let numBags

    containerCopy.numBoxes = numBoxes
    containerCopy.type = containerType

    if (dimensions.count) numBags = Math.ceil(dimensions.count / numBoxes)
    if (numBags) containerCopy.numBags = numBags
    if (numBags) containerCopy.count = dimensions.count

    return containerCopy
  }

  redirect = (dimensions) => {
    this.props.history.push({
      pathname:
        window.location.pathname == "/togo-don"
          ? "/togo-don/search"
          : "/togo/search",
      state: {
        boxes: this.state.displayBoxes,
        bags: this.state.displayBags,
        dimensions: dimensions, // dimensions carries a lot of state, pushing it onto another route
        locale: this.props.locale,
      },
    })
  }

  updateLanguage = (event) => {
    this.props.updateLanguage(event.target.value)
  }

  render() {
    return (
      <div className="container-fluid">
        <Layout
          languages={this.props.languages}
          handler={this.updateLanguage}
          locale={this.props.locale}
        />
        <div>
          <div className="col-sm-3 left-page">
            <img
              src={`/assets/logo_togo-container-solution-${this.props.locale}.jpg`}
              className="img-responsive center-block logo hidden-xs"
            />
            <img
              src={`/assets/logo_togo-container-solution-mobile-${this.props.locale}.jpg`}
              className="img-responsive center-block visible-xs"
            />
            <br />
            <div className="hidden-xs">
              <img
                src={"/assets/gobag_sidebar-image.jpg"}
                className="img-responsive center-block hidden-xs"
                width="225px"
              />
              <br />
              <img
                src={"/assets/gobag_sidebar-image-2.jpg"}
                className="img-responsive center-block hidden-xs"
                width="225px"
              />
            </div>
          </div>
          <div className="col-sm-9 right-page">
            <div className="col-sm-8">
              <h2>
                <FormattedMessage id="togo.title" />
              </h2>
              <h3>
                <FormattedMessage id="togo.subtitle" />
              </h3>
              <Calculator
                setContainerState={this.setContainerState}
                containers={this.props.containers}
                food_pans={this.props.food_pans}
              />
            </div>
            <div className="col-sm-4 hidden-xs">
              <img
                src={`/assets/gobag_dimensions-example-${this.props.locale}.png`}
                className="img-responsive center-block"
              />
              <br />
              <div className="togo-title">
                <FormattedMessage id="togo.measurement_instructions.title" />
              </div>
              <br />
              <div className="col-xs-3 text-right togo-title">
                <FormattedMessage id="togo.measurement_labels.width.title" />:
              </div>
              <div className="col-xs-9">
                <p>
                  <FormattedMessage id="togo.measurement_labels.width.description" />
                </p>
              </div>
              <div className="col-xs-3 text-right togo-title">
                <FormattedMessage id="togo.measurement_labels.height.title" />:
              </div>
              <div className="col-xs-9">
                <p>
                  <FormattedMessage id="togo.measurement_labels.height.description" />
                </p>
              </div>
              <div className="col-xs-3 text-right togo-title">
                <FormattedMessage id="togo.measurement_labels.length.title" />:
              </div>
              <div className="col-xs-9">
                <p>
                  <FormattedMessage id="togo.measurement_labels.length.description" />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withI18n(App)
